<template>
  <textarea
    :name="name"
    :disabled="disabled"
    :placeholder="placeholder"

    :value="value"

    :class="classes"

    @input="input"
    @blur="blur"
    @focus="focus"
  />
</template>

<script>
  export default {
    name: 'CordelTextarea',
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      classes() {
        const classes = ['cordel-textarea'];

        if (this.errors.length) {
          classes.push('state--error');
        }

        if (this.disabled) {
          classes.push('state--disabled');
        }

        if (this.loading) {
          classes.push('state--loading');
        }

        return classes;
      },
    },
    methods: {
      input(e) {
        this.$emit('input', e.target.value);
      },
      blur(e) {
        this.$emit('blur', e);
        this.$emit('change', e);
      },
      focus(e) {
        this.$emit('focus', e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-textarea {
    @include cordel-input-reset;

    background-color: var(--cordel-legacy-color-neutral-lighter);
    border-radius: var(--cordel-legacy-border-radius-small);
    box-shadow: 0 0 0 var(--cordel-legacy-border-width-soft) var(--cordel-legacy-color-neutral-primary);
    min-height: calc(var(--cordel-legacy-spacing-xxxs) + 3rem + var(--cordel-legacy-spacing-xxxs));
    padding: var(--cordel-legacy-spacing-xxxs) var(--cordel-legacy-spacing-xxs);
    resize: vretical;

    &::placeholder {
      color: var(--cordel-legacy-color-neutral-primary);
    }

    &:focus {
      box-shadow: 0 0 0 var(--cordel-legacy-border-width-thin) var(--cordel-legacy-color-highlight-primary);
    }
  }

  .state--error {
    box-shadow: 0 0 0 var(--cordel-legacy-border-width-thin) var(--cordel-legacy-color-alert-danger);
  }

  .state--disabled {
    box-shadow: 0 0 0 var(--cordel-legacy-border-width-soft) var(--cordel-legacy-color-neutral-primary);
    color: var(--cordel-legacy-color-neutral-primary);
    cursor: not-allowed;
  }

  .state--loading {
    box-shadow: 0 0 0 var(--cordel-legacy-border-width-soft) var(--cordel-legacy-color-neutral-primary);
    color: var(--cordel-legacy-color-neutral-primary);
    cursor: progress;
  }
</style>
